import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

const styles = css`
  position: relative;
  margin-top: 0;
  background: rgba(46, 67, 109, 0.9);
  z-index: 10;
  @media (min-width: 991px) {
    margin-top: -70px;
  }
  .InternalMenu_mobileToggler {
    width: 100%;
    height: 50px;
    background-image: none;
    background-color: transparent;
    padding: 0;
    border:none;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.142857em;
    line-height: 1;
    text-transform: uppercase;
    color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::after {
      content: '';
      display: inline-block;
      margin-left: 10px;
      width: 0px;
      height: 0px;
      border: none;
    }
    &::before{
      content: '';
      height: 10px;
      width: 10px;
      background-image: url('/images/i-arrow-down-gold.svg');
      background-size: 10px 10px;
      position: absolute;
      right: 20px;
    }
    &:focus {
      outline: none;
    }
    @media (min-width: 768px) {
      display: none;
    }
  }
  .InternalMenu_inner {
    background-color: ${colors.color1Dark};
    @media (min-width: 768px) {
      display: flex;
      justify-content: center;
      padding: 0 24px;
      background-color: transparent;
    }
    @media (min-width: 992px) {
      padding: 0 68px;
    }
    @media (min-width: 1440px) {
      padding: 0 98px;
    }
  }
  .InternalMenu_inner-closed {
    @media (max-width: 767.98px) {
      display: none;
    }
  }
  .InternalMenu_link {
    display: block;
    color: white;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: center;
    text-transform: uppercase;
    border-bottom: solid 1px ${colors.color1Light};
    &:hover {
      text-decoration: none;
    }
    @media (min-width: 768px) {
      font-size: 14px;
      padding: 0 16px;
      border-bottom: none;
    }
    @media (min-width: 992px) {
      font-size: 18px;
      padding: 0 22px;
    }
  }
  .InternalMenu_linkText {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background-color: transparent;
    border-bottom: 3px solid transparent;
    @media (min-width: 768px) {
      display: inline-flex;
    }
    @media (min-width: 992px) {
      border-bottom-width: 3px;
      height: 70px;
    }
  }
  .InternalMenu_link.active {
    @media (min-width: 768px) {
      .InternalMenu_linkText {
        border-bottom-color: ${colors.color2Light};
      }
    }
  }
  .InternalMenu_link:not(.active):hover {
    @media (min-width: 992px) {
      transition: background-color 300ms ease;
      &:hover {
        background-color: ${colors.color1Dark};
      }
    }
  }
`;


function InternalMenu({ activateMenu, isActiveMenu, links, menuName }) {
  return (
    <nav className={styles}>
      <button
        className="InternalMenu_mobileToggler"
        type="button"
        onClick={activateMenu('internal-menu')}
        aria-label={`Toggle ${menuName} menu`}
      >{`${menuName} Menu`}</button>
      <div className={`InternalMenu_inner ${!isActiveMenu('internal-menu') && 'InternalMenu_inner-closed'}`}>
        {
          links.filter(link => link.internal !== false).map(link => {
            const irrelevantKeys = ['text', 'route', 'header', 'footer', '_id'];
            const linkProps = omit(link, irrelevantKeys);
            return (
              <Link
                className="InternalMenu_link"
                name={link.route}
                key={link._id}
                {...linkProps}
              >
                <span className="InternalMenu_linkText">{link.text}</span>
              </Link>
            );
          })
        }
      </div>
    </nav>
  );
}

InternalMenu.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuName: PropTypes.string.isRequired,
};

export default menuToggler(InternalMenu);



// WEBPACK FOOTER //
// ./src/components/InternalMenu.js